import { useMemo } from 'react';

// TODO: Update styles
export const useOptions = () => {
  const fontSize = '14px';
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'sans-serif',
          '::placeholder': {
            color: '#70768D',
          },
        },
        invalid: {
          color: '#d2451e',
        },
      },
      hidePostalCode: true,
    }),
    [fontSize]
  );

  return options;
};

export const getOrderTotalCost = (orderTotal: string) =>
  parseInt((parseFloat(orderTotal) * 100).toString()) || 0;
